import { useSelector } from 'react-redux';

import ClipboardCopyableText from '@app/components/ClipboardCopyableText';
import PENDING_TYPE from '@app/constants/pendingType';
import { getDocument } from '@app/store/signingProgressInformation/selectors';

function DocumentInfo() {
  const document = useSelector(getDocument);

  const { documentId, originHash, name, statusWithPending, pending } = document;

  let pendingName = '';
  let pendingCreator = '';
  if (pending?.pendingType === PENDING_TYPE.REJECTION) {
    pendingName = '서명 거절';
    pendingCreator = '거절한 서명자';
  }
  if (pending?.pendingType === PENDING_TYPE.SIGNING_CANCELLATION) {
    pendingName = '서명 취소';
    pendingCreator = '취소한 서명자';
  }
  if (pending?.pendingType === PENDING_TYPE.REQUEST_CANCELLATION) {
    pendingName = '요청 취소';
    pendingCreator = '취소한 요청자';
  }

  return (
    <div className="box-5x">
      <h5 className="space-3x">문서 정보</h5>
      <table className="InfoTable">
        <tbody>
          <tr>
            <th className="InfoTable__label-cell">문서 이름</th>
            <td className="InfoTable__value-cell">{name}</td>
          </tr>
          <tr>
            <th className="InfoTable__label-cell">문서 ID</th>
            <td className="InfoTable__value-cell">
              <ClipboardCopyableText
                color="textNeutralBase"
                fontSize="md"
                fontWeight="medium"
                label="문서 ID"
              >
                {documentId ?? ''}
              </ClipboardCopyableText>
            </td>
          </tr>
          {originHash && (
            <tr>
              <th className="InfoTable__label-cell">원본 검증키</th>
              <td className="InfoTable__value-cell">
                <ClipboardCopyableText
                  color="textNeutralBase"
                  fontSize="md"
                  fontWeight="medium"
                  label="원본 검증키"
                >
                  {originHash}
                </ClipboardCopyableText>
              </td>
            </tr>
          )}

          <tr>
            <th className="InfoTable__label-cell">서명 진행 상태</th>
            <td className="InfoTable__value-cell">{statusWithPending}</td>
          </tr>
          {pending?.pendingType && (
            <>
              <tr>
                <th className="InfoTable__label-cell">{pendingCreator}</th>
                <td className="InfoTable__value-cell">
                  {pending.pendingCreator.name} ({pending.pendingCreator.contactInfo})
                </td>
              </tr>
              <tr>
                <th className="InfoTable__label-cell">{pendingName} 사유</th>
                <td className="InfoTable__value-cell">{pending.reason}</td>
              </tr>
            </>
          )}
          <tr>
            <th className="InfoTable__label-cell">기준 시간</th>
            <td className="InfoTable__value-cell">사용자 컴퓨터 시간 기준</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default DocumentInfo;
